module.exports = __webpack_public_path__ + "img/test-times-up.78fc0c2e.svg";